<template>
  <div class="dcf-grid dcf-row-gap-5 dcf-col-gap-5">
    <div class="dcf-col-100%">
      <div class="dcf-form dcf-d-flex">
        <div class="dcf-input-radio dcf-mr-2"><input type="radio" name="nameDisplay" v-model="nameDisplay" value="scientific" id="viewScientific"> <label for="viewScientific">Scientific Name</label></div>
        <div class="dcf-input-radio dcf-mr-2"><input type="radio" name="nameDisplay" v-model="nameDisplay" value="common" id="viewCommon"> <label for="viewCommon">Common Name</label></div>  
        <!--<div class="dcf-input-radio"><input type="radio" name="nameDisplay" v-model="nameDisplay" value="skeleton" id="viewSkeleton"> <label for="viewSkeleton">Skeleton View</label></div>--> 
      </div>
    </div>

    <div class="dcf-col-100% dcf-col-25%-start@md" v-if="nameDisplay == 'scientific' || nameDisplay == 'common'">
    
      <div class="unl-font-sans unl-bg-lightest-gray dcf-p-2 bov-list">
        <ul class="dcf-list-bare dcf-txt-sm">
          <li v-for="bone in sortedBones" :class="(activeBoneId == bone.id) ? 'dcf-pl-1 active' : 'dcf-pl-1 '" v-if="bone.common_name != ''">
            <a class="dcf-txt-decor-none" href="#" v-on:click.prevent="activeBoneId = bone.id" v-text="(nameDisplay == 'scientific') ? bone.name : bone.common_name"></a>
          </li>
        </ul>
      </div>      
    </div>
    <!--<div class="dcf-col-50%-start" v-if="nameDisplay == 'skeleton'">
      <svg viewBox=" 0 0 1225 484">
        <use href="#illustration_outline" fill="#CCCCCC" />
        <use href="#bone_fill" fill="#FFFFFF" />
        <use v-for="bone in illustratedBones" :href="'#bone_' + bone" class="clicky_bone" v-on:click.prevent="activeBoneId = bone" />
        <use :href="'#bone_' + activeBoneId" fill="#00FF00" />
        <use href="#bone_outlines" />
      </svg>
    </div>-->

    <div class="dcf-col-100% dcf-col-75%-end@md" v-if="activeBoneId">    
      <bone :bone="activeBone" :hideSVG="false"></bone>
    </div>
  </div>

</template>

<style>
.clicky_bone {
  fill: transparent;
  cursor: pointer;
}
.clicky_bone:hover {
  fill: #0000FF;
}
</style>

<script>
import bone from './bone.vue';

export default {
  components: { bone },
  data: function(){
    return {
      bones: [],
      activeBoneId: false,
      nameDisplay: 'scientific',
      illustratedBones: []
    }
  },
  computed: {
    sortedBones: function(){
      var output = this.bones;
      var sortType = (this.nameDisplay == 'scientific' || this.nameDisplay == 'common') ? this.nameDisplay : 'common';

      output = output.sort(function(a, b){
        var key = (sortType == 'scientific') ? 'name' : 'common_name';

        a[key] = (a[key] == null) ? '' : a[key];
        b[key] = (b[key] == null) ? '' : b[key];

        if(a[key].toUpperCase() < b[key].toUpperCase()){
          return -1;
        }
        if(a[key].toUpperCase() > b[key].toUpperCase()){
          return 1;
        }
        return 0;

      });

      return output;
    },
    activeBone: function(){
      var $this = this;
      return this.activeBoneId ? this.bones.find( function(v){ return v.id == $this.activeBoneId }) : false;
    }
  },
  methods: {

  },
  created: function(){
    this.bones = window.bones;
    this.illustratedBones = window.illustrated_bones;
  }
}
</script>

